import {Component, OnInit} from '@angular/core';
import {DataService, OrientDBCollectionView} from '@cosbeni/database';
import {ActivePromotionConfig} from '../config/active-promotion.config';

/**
 * 買取屋 商品管理 (旧 kaitoriya.app /admin `cj-admin-product` の移植)。
 *
 * OrientDB クラス `AP_Product` を OrientDBCollectionView で一覧・追加・編集・削除する。
 * 保存は CollectionView 経由 (`saveChanges()` / `cancelChanges()`) で SQL は使わない。
 * 顧客管理 (KaitoriyaCustomerManagementComponent) と同じ流儀。
 */
@Component({
    standalone: false,
    selector: 'app-kaitoriya-product',
    templateUrl: 'product-management.component.html',
})
export class KaitoriyaProductManagementComponent implements OnInit {
    products: OrientDBCollectionView;
    readonly = true;

    constructor(private dataService: DataService) {
        this.products = new OrientDBCollectionView(this.dataService, ActivePromotionConfig.DATABASE,
            'SELECT FROM AP_Product', 'AP_Product', '', 0, 100, true, true, false);
        this.products.url = ActivePromotionConfig.SERVER_URL;
        this.products.tokenName = ActivePromotionConfig.DATABASE + '_token';
    }

    ngOnInit(): void {
        this.products.filterOnServer = true;
    }
}
